<script setup lang="ts">
import type { CtaDescriptor } from '~/utils/event-policy';

const props = defineProps<{
  cta: CtaDescriptor;
  eventId: string;
}>();

const emit = defineEmits<{
  commit: [];
  purchase: [];
  withdraw: [];
}>();

const route = useRoute();

function handleClick() {
  switch (props.cta.action) {
    case 'login':
      navigateTo(
        `/login?redirect_to=${encodeURIComponent(route.path)}` +
          `&event_id=${encodeURIComponent(props.eventId)}`,
      );
      break;
    case 'commit':
      emit('commit');
      break;
    case 'purchase':
      emit('purchase');
      break;
    case 'withdraw':
      emit('withdraw');
      break;
  }
}

const vuetifyVariant = computed(() => {
  switch (props.cta.variant) {
    case 'primary':
      return 'flat';
    case 'outlined':
      return 'outlined';
    case 'text':
      return 'text';
    default:
      return 'flat';
  }
});

const vuetifyColor = computed(() =>
  props.cta.variant === 'primary' ? 'primary' : undefined,
);
</script>

<template>
  <div v-if="cta.label || cta.action !== 'none'" class="event-cta-module">
    <v-tooltip
      v-if="cta.disabled && cta.disabledReason"
      :text="cta.disabledReason"
      location="top"
    >
      <template #activator="{ props: tooltipProps }">
        <div v-bind="tooltipProps">
          <v-btn
            block
            rounded
            :variant="vuetifyVariant"
            :color="vuetifyColor"
            disabled
          >
            {{ cta.label }}
          </v-btn>
        </div>
      </template>
    </v-tooltip>
    <v-btn
      v-else
      block
      rounded
      :variant="vuetifyVariant"
      :color="vuetifyColor"
      :disabled="cta.disabled"
      @click="handleClick"
    >
      {{ cta.label }}
    </v-btn>
  </div>
</template>
